import {ErrorMessage, Form, Formik} from 'formik';
import {useTranslation} from 'next-i18next';
import PropTypes from 'prop-types';
import React, {useContext} from 'react';
import * as Yup from 'yup';

import useLoading from '@/src/hooks/useLoading';
import TextLocal from '@/src/textLocal/containers/TextLocal';

import PopupContext from '../../popup/utils/PopupContext';
import {
  Button,
  LoadingWrapper,
  SelectableRating,
  Separator,
  Text,
  Textarea,
} from '../../ui';
import css from '../styles/LeaveReviewPopup.module.css';

const getValidationSchema = (t) => {
  return Yup.object().shape({
    rating: Yup.string().required(t('validation.field-req')),
  });
};

const WriteReviewPopup = ({onAddNewReviewClick}) => {
  const {isLoading, setLoading} = useLoading();
  const {t} = useTranslation('common');
  const {closePopup} = useContext(PopupContext);

  const handleSaveFormClick = async (values) => {
    setLoading(true);

    await onAddNewReviewClick(values);

    closePopup();
    setLoading(false);
  };

  return (
    <div className={css.leaveReviewModal}>
      <Formik
        initialValues={{
          rating: '',
          comment: '',
        }}
        validationSchema={getValidationSchema(t)}
        onSubmit={handleSaveFormClick}
      >
        <LoadingWrapper isLoading={isLoading}>
          <Form>
            <div className={css.header}>
              <Text
                fontSize={Text.FONT_SIZE.SIZE_32}
                fontFamily={Text.FONT_FAMILY.RUBIK}
                fontWeight={Text.FONT_WEIGHT.MEDIUM}
              >
                <TextLocal id={'courseDetails.leave-your-review'} />
              </Text>
            </div>
            <Separator />
            <div className={css.content}>
              <Text
                fontSize={Text.FONT_SIZE.SIZE_24}
                fontFamily={Text.FONT_FAMILY.RUBIK}
                fontWeight={Text.FONT_WEIGHT.MEDIUM}
              >
                <TextLocal id={'courseDetails.what-you-think-about-course-q'} />
              </Text>
              <div className={css.rating}>
                {/*@ts-ignore*/}
                <SelectableRating name={'rating'} />
                <ErrorMessage name="rating">
                  {(msg) => (
                    <Text
                      color={Text.COLOR.RED}
                      lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_24}
                      fontSize={Text.FONT_SIZE.SIZE_12}
                    >
                      {msg}
                    </Text>
                  )}
                </ErrorMessage>
              </div>

              {/*@ts-ignore*/}
              <Textarea
                minRows={Textarea.ROWS.ROWS_6}
                name={'comment'}
                placeholder={t('courseDetails.write-your-review')}
              />
            </div>
            <Separator />
            <div className={css.buttons}>
              <div className={css.cancel} onClick={closePopup}>
                <Text color={Text.COLOR.GREY}>
                  <TextLocal id={'general.cancel'} />
                </Text>
              </div>
              <Button height={Button.HEIGHT.REGULAR}>
                <TextLocal id={'general.add'} />
              </Button>
            </div>
          </Form>
        </LoadingWrapper>
      </Formik>
    </div>
  );
};

WriteReviewPopup.propTypes = {
  onAddNewReviewClick: PropTypes.func.isRequired,
};

export default WriteReviewPopup;
